var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-4" },
    [
      _c(
        "b-form-group",
        { attrs: { state: false } },
        [
          _c(
            "b-card",
            {
              class: _vm.v.$invalid ? "form-invalid" : "form-valid",
              attrs: { "no-body": "" },
            },
            [
              _c(
                "b-card-body",
                [
                  _c("b-table", {
                    staticClass: "table-atmo mb-0",
                    attrs: {
                      id: "my-table",
                      fields: _vm.fields,
                      items: _vm.items,
                      "show-empty": "",
                      small: "",
                      responsive: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "head(actions)",
                        fn: function () {
                          return [
                            _c("action-button-small", {
                              attrs: {
                                icon: "plus-square",
                                title: "Добавить описание требования",
                              },
                              on: { click: _vm.addItem },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "cell(index)",
                        fn: function (data) {
                          return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
                        },
                      },
                      {
                        key: "cell(description)",
                        fn: function (data) {
                          return [
                            _c("b-form-input", {
                              staticClass: "mb-0 form-control fs-14",
                              class: !_vm.v.$each[data.index].description
                                .$invalid
                                ? "is-valid"
                                : "is-invalid",
                              model: {
                                value: data.item.description,
                                callback: function ($$v) {
                                  _vm.$set(data.item, "description", $$v)
                                },
                                expression: "data.item.description",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(reason)",
                        fn: function (data) {
                          return [
                            _c("b-form-input", {
                              staticClass: "mb-0 form-control fs-14",
                              class: !_vm.v.$each[data.index].reason.$invalid
                                ? "is-valid"
                                : "is-invalid",
                              model: {
                                value: data.item.reason,
                                callback: function ($$v) {
                                  _vm.$set(data.item, "reason", $$v)
                                },
                                expression: "data.item.reason",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c("action-button-small", {
                              attrs: { icon: "trash", title: "Удалить" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeItem(data.index)
                                },
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "empty",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "w-100 text-center text-danger" },
                              [_vm._v("Добавьте описание требования")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }